import { render, staticRenderFns } from "./father_current_info.vue?vue&type=template&id=15927c38&scoped=true&"
import script from "./father_current_info.vue?vue&type=script&lang=js&"
export * from "./father_current_info.vue?vue&type=script&lang=js&"
import style0 from "./father_current_info.vue?vue&type=style&index=0&id=15927c38&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15927c38",
  null
  
)

export default component.exports